// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1_NXS","range":"MonthRangeSwitch_range__1hw6e","disabled":"MonthRangeSwitch_disabled__3ui9A"};